import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, NgZone, inject } from '@angular/core';

import { ChartDataInterfaceComponent } from '@utils/widgets/chart-data-interface.component';
import { LayoutBounds } from '@utils/widgets/layout';
import { TreemapChartData, TreemapChartOptionFactory, TreemapChartSettings } from './mapping';

import { HighchartsDirective, HighchartsSizeStrategy } from '@utils/charts/highcharts.directive';
import { CustomEvents } from '@utils/events/custom-events';
import { EventContext } from '@utils/events/event-context';
import * as Highcharts from 'highcharts';
import heatmap from 'highcharts/modules/heatmap';
import treemap from 'highcharts/modules/treemap';

heatmap(Highcharts);
treemap(Highcharts);

@Component({
  selector: 'app-treemap-chart',
  standalone: true,
  imports: [CommonModule, HighchartsDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './treemap-chart.component.html',
  styleUrls: ['./treemap-chart.component.scss'],
})
export class TreemapChartComponent extends ChartDataInterfaceComponent<
  TreemapChartData,
  TreemapChartSettings,
  LayoutBounds
> {
  @Input({ required: false }) sizeStrategy?: HighchartsSizeStrategy | undefined;

  protected options: Highcharts.Options | undefined;

  protected readonly eventContext = inject(EventContext, { optional: true });
  private readonly zone = inject(NgZone);

  protected override dataUpdate(): void {
    if (!this.data) {
      return;
    }

    this.options = new TreemapChartOptionFactory(this.eventContext ? this.onClick : null, 0, 2).getOptions(
      this.data,
      this.settings,
      this.layout
    );
  }

  protected readonly onClick = (key: string): void => {
    this.zone.run(() => this.eventContext.dispatch(CustomEvents.TreeMapClick, key));
  };
}
